import { getApi } from './api_instance'

export const getAverageBidPrice = async dispatch => {
  try {
    const response = await getApi({
      apiUrl: `/projects/api/average-bid-price`,
      dispatch
    })
    return response
  } catch (error) {
    throw error
  }
}
